<template>
  <div class="Dashboard">
    Dashboard
  </div>
</template>

<script>
import router from "@/router";
export default {
  name: "Dashboard",
  setup() {
    router.replace({ path: "/reports/benchmarking/7" });
  }
};
</script>
